import dataPeriTarDaptPra from "../../../../src/data/periprocedureel-beleid-tar-dapt-asa-pra-clo-tic.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataPeriTarDaptPra,
  BasicSchematic,
  React
};